import React, { useState } from 'react'
export const Context = React.createContext()

const createEmptyUtilityGroups = () => Array.from({ length: 8 }, () => [])

const ContextProvider = (props) => {
    const [currentUser, setCurrentUser] = useState({})
    const [isOps, setIsOps] = useState(false)
    const [isSales, setIsSales] = useState(false)
    const [isTech, setIsTech] = useState(false)
    const [isAdmin, setIsAdmin] = useState(false)
    const [userType, setUserType] = useState('')
    const [choices, setChoices] = useState({})
    const [goals, setGoals] = useState([])
    const [products, setProducts] = useState(createEmptyUtilityGroups)
    const [providers, setProviders] = useState(createEmptyUtilityGroups)
    const [providersList, setProvidersList] = useState([])
    const [providersDict, setProvidersDict] = useState([]);
    const [partnerProviders, setPartnerProviders] = useState(createEmptyUtilityGroups)
    const [partnerProvidersList, setPartnerProvidersList] = useState([])
    const [partnerProvidersDict, setPartnerProvidersDict] = useState([]);
    const [nonWaterPartnerProvidersDict, setNonWaterPartnerProvidersDict] = useState([]);
    const [operationsAgents, setOperationsAgents] = useState({})
    const [okismartAccountManagers, setOkismartAccountManagers] = useState({})
    const [accountManagers, setAccountManagers] = useState({})
    const [customerService, setCustomerService] = useState({})
    const [salesAgents, setSalesAgents] = useState({})
    const [techAgents, setTechAgents] = useState({})
    const [agencys, setAgencys] = useState({all: [], 0: [], 1: []})
    const [agencysList, setAgencysList] = useState({all: [], 0: [], 1: []})
    const [agencysDict, setAgencysDict] = useState({all: [], 0: [], 1: []})
    const [country, setCountry] = useState('')
    const [headers, setHeaders] = useState('')
    const [numUtilityTypesOkieasy, setNumUtilityTypesOkieasy] = useState('')
    const [numUtilityTypes, setNumUtilityTypes] = useState('')
    const [numServiceTypes, setNumServiceTypes] = useState('')
    const [insuranceProducts, setInsuranceProducts] = useState([])
    const [insuranceProviders, setInsuranceProviders] = useState([])
    const [insuranceProvidersDict, setInsuranceProvidersDict] = useState([])
    const [buildings, setBuildings] = useState([])
    const [buildingsAgencyDict, setBuildingsAgencyDict] = useState({})
    const [serviceHolders, setServiceHolders] = useState([])
    const [erpApps, setErpApps] = useState([])
    const ENV = process.env.REACT_APP_ENV_URL || 'http://localhost:8000';
    const API = process.env.REACT_APP_API_URL || 'http://localhost:8000/api/core/';
    const LANDING_URL = process.env.REACT_APP_LANDING_URL || 'http://localhost:3000/';

    return (
         <Context.Provider 
            value={{
                currentUser, setCurrentUser,
                isOps, setIsOps,
                isSales, setIsSales,
                isTech, setIsTech,
                isAdmin, setIsAdmin,
                userType, setUserType,
                choices, setChoices,
                goals, setGoals,
                products, setProducts,
                providers, setProviders,
                providersList, setProvidersList,
                providersDict, setProvidersDict,
                partnerProviders, setPartnerProviders,
                partnerProvidersList, setPartnerProvidersList,
                partnerProvidersDict, setPartnerProvidersDict,
                nonWaterPartnerProvidersDict, setNonWaterPartnerProvidersDict,
                operationsAgents, setOperationsAgents,
                okismartAccountManagers, setOkismartAccountManagers,
                accountManagers, setAccountManagers,
                customerService, setCustomerService,
                salesAgents, setSalesAgents,
                techAgents, setTechAgents,
                agencys, setAgencys,
                agencysList, setAgencysList,
                agencysDict, setAgencysDict,
                country, setCountry,
                headers, setHeaders,
                numUtilityTypesOkieasy, setNumUtilityTypesOkieasy,
                numUtilityTypes, setNumUtilityTypes,
                numServiceTypes, setNumServiceTypes,
                insuranceProducts, setInsuranceProducts,
                insuranceProviders, setInsuranceProviders,
                insuranceProvidersDict, setInsuranceProvidersDict,
                buildings, setBuildings,
                buildingsAgencyDict, setBuildingsAgencyDict,
                serviceHolders, setServiceHolders,
                erpApps, setErpApps,
                ENV,
                API,
                LANDING_URL,
             }}>
             {props.children}
         </Context.Provider>
    )
}
export default ContextProvider
